module.exports = {
  src: __webpack_public_path__ + "static/media/frontpage_00014.7bb05c4e.jpg",
  width: 2000,
  height: 1571,
  bytes: 544533,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/frontpage_00014.7bb05c4e.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/frontpage/frontpage_00014.jpg
// module id = 175
// module chunks = 0